import { Button, type ButtonProps } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiMessageSquare } from "react-icons/fi";
import type { AiResultHandoff } from "./aiResultHandoff";
import { useAskFurther } from "./useAskFurther";

type Props = {
  result: () => AiResultHandoff | null;
  beforeOpen?: () => void;
} & Pick<ButtonProps, "size" | "colorScheme" | "isDisabled">;

export const AskFurtherButton = ({ result, beforeOpen, size = "xs", colorScheme = "teal", isDisabled }: Props) => {
  const { t } = useTranslation();
  const askFurther = useAskFurther();
  if (!askFurther) return null;

  const onClick = () => {
    const handoff = result();
    if (!handoff || !handoff.text.trim()) return;
    beforeOpen?.();
    askFurther(handoff);
  };

  return (
    <Button
      leftIcon={<FiMessageSquare />}
      variant="ghost"
      colorScheme={colorScheme}
      size={size}
      onClick={onClick}
      isDisabled={isDisabled}
    >
      {t("Ask further")}
    </Button>
  );
};
